const loader = require(`loader`);
const modal = require(`modal`);
const notification = require(`notification`);
const formValidation = require(`formValidation`);
const userService = require(`userService`);
const teamService = require(`teamService`);

// Functions shared across both Club and Team manage pages
const manageMembers = (function () {
  const $managePage = $(`.manage-members`);
  let enteredEmail = null;
  let upgradesRemaining = null;
  let newPlan = null;
  const clubID = $(`body`).attr(`data-club-id`);
  let teamID = $(`.manage-members`).attr(`data-team-id`);
  let buttonClicked = null;

  const handleAddMemberClick = function () {
    $(`.add-new-member-container`).hide();
    $(`.add-member`).on(`click`, function (e) {
      e.preventDefault();
      $(this).closest(`.panel`).find(`.add-new-member-container`).slideToggle();
    });
  };

  const handleFormValidation = function () {
    $(`.add-new-member-container form`).each(function() {
      const $this = $(this);
      $(this).validate({
        rules: {
          email: {
            required: true,
            email: true,
          },
        },
        submitHandler() {
          $(`window`).showLoader();
          const $submittedForm = $this.find(`.email-input`);
          getData($submittedForm);
        },
      });
    });
  };

  const getData = function($submittedForm) {
    // Get all of the data needed to make an informed decision!
    enteredEmail = $submittedForm.val();
    upgradesRemaining = $submittedForm.attr(`data-upgrade-remaining`);
    newPlan = $submittedForm.attr(`data-upgrade-plan`);
    buttonClicked = $submittedForm.attr(`id`);
    submitNewUser();
  };

  const submitNewUser = function () {
    // Check if the entered email address is from a verified TCM user
    userExistsService(enteredEmail, checkIfVerified);
  };

  const checkIfVerified = function (response) {
    // If they are verified, check what they are being added as and if they need upgrading
    if (response.data === true) {
      userNeedsUpgradeService(enteredEmail, newPlan, teamID, doesUserNeedUpgrade);
    // Else, if they are not verified we need to create them an account
    } else if (buttonClicked !== `add-admin`) {
      $(`window`).modal({
        title: `Do you want us to invite this person?`,
        content: `
          <p>The email address <strong>${enteredEmail}</strong> is not registered with The Coaching Manual. Would you like us to send this person an invite to create an account?*</p>
          <form class="side-by-side-inputs">
            <div class="form-group">
              <input id="invite-first-name" class="form-control" type="text" placeholder="First Name">
            </div>
            <div class="form-group">
              <input id="invite-last-name" class="form-control" type="text" placeholder="Last Name">
            </div>
          </form>
          <p class="like-small color-grey">*By selecting ‘Send Invite’ you are confirming that you have permission to add this user via their email address. If you are adding players you are also confirming that they are over 13 years of age. If they are below 13 years of age you are confirming that you are using the email address of their parent. You may anonymise users by using generic names such as Player 1.</p>
        `,
        confirmText: `Send Invite`,
        complete() {
          inviteUser();
        },
      });
    } else {
      $('window').modal({
        title: `User does not exist`,
        content: `<p>The email address <strong>${enteredEmail}</strong> is not a registered user of The Coaching Manual. If you want to add them as an admin on your club, please ask them to sign up to the club account <a href="${window.location.href}/signup">here</a></p>`,
        confirmText: `Dismiss`,
        complete() {},
      });
    }
  };

  const doesUserNeedUpgrade = function (response) {
    // Check if the user needs to be upgraded
    if (response.data.result === true) {
      canUserPerformUpgrade(response);
    } else {
      checkButtonClick(false);
    }
  };

  const canUserPerformUpgrade = function (response) {
    // Check that we have the right access to upgrade the user
    if (response.data.AbleToPerformUpgrade === true) {
      checkUpgradesRemaining(response);
    } else {
      const clubOwnerID = $(`.manage-members`).attr(`data-club-owner-id`);
      $(`window`).modal({
        title: `This member requires an upgrade.`,
        content: `This member needs upgrading to be added, but you don't have permissions to assign the upgrade. Please contact the club owner and ask them to add this user.`,
        confirmText: `Go to club owners profile`,
        complete() {
          window.location.href = `/user/${clubOwnerID}`;
        },
      });
    }
  };

  const checkButtonClick = function (allocateLicence, invite, firstName, lastName) {
    switch (buttonClicked) {
      case `add-coach`:
        addCoachToTeamService(teamID, enteredEmail, invite, firstName, lastName, allocateLicence, addMemberCallback);
        break;
      case `add-head-coach`:
        addHeadCoachToTeamService(teamID, enteredEmail, invite, firstName, lastName, allocateLicence, addMemberCallback);
        break;
      case `add-admin`:
        addAdminToClubService(clubID, enteredEmail, invite, addMemberCallback);
        break;
      case `add-player`:
        addPlayerToTeamService(teamID, enteredEmail, invite, firstName, lastName, allocateLicence, addMemberCallback);
      // no default
    }
  };

  const checkUpgradesRemaining = function (response) {
    if (upgradesRemaining <= 0) {
      $(`window`).modal({
        title: `No upgrades available`,
        content: `This member needs upgrading to be added, but you don't have any upgrades left. Please contact us for a personalised quote in order to upgrade more members.`,
        confirmText: `Contact us`,
        complete() {
          window.location.href = `mailto:info@thecoachingmanual.com`;
        },
      });
    } else {
      $(`window`).modal({
        title: response.data.title,
        content: response.data.message,
        confirmText: response.data.confirmText,
        complete () {
          checkButtonClick(true);
        },
      });
    }
  };

  const addMemberCallback = function (response) {
    if (response.statusCode === 200) {
      $(`window`).notification({ title: response.message });
      // Temp Fix
      location.reload();
    } else if (response.statusCode === 403) {
      $(`window`).modal({
        title: response.data.title,
        content: response.data.message,
        confirmText: response.data.confirmText,
      });
    } else {
      $(`window`).notification({ title: response.message, error: true });
    }
  };

  const inviteUser = function () {
    const firstName = $(`#invite-first-name`).val();
    const lastName = $(`#invite-last-name`).val();
    checkButtonClick(false, true, firstName, lastName);
  };

  const handleRemoveMemberClick = function () {
    $(`.remove-member`).on(`click`, function (e) {
      e.preventDefault();
      const memberID = $(this).attr(`data-user-id`) || ``;
      const memberType = $(this).attr(`data-member-type`) || ``;

      $(this).addClass(`member-to-remove`);

      if (memberType === `team`) {
        teamID = $(this).attr('data-team-id') || ``;
        $(`window`).modal({
          title: `Are you sure you want to delete this team?`,
          content: `You won't be able to recover this team after deleting. Any team members who are occupying upgrades will be credited back to your account.`,
          confirmText: `Delete team`,
          complete() {
            $(`window`).showLoader();
            removeItem(memberID, teamID, 0, memberType);
          },
        });
      } else {
        $(`window`).modal({
          title: `Are you sure you want to remove this member?`,
          content: `Any coaches or players you remove can be added again at any time.`,
          confirmText: `Remove member`,
          complete() {
            $('window').showLoader();
            removeItem(memberID, teamID, clubID, memberType);
          },
        });
      }
    });
  };

  const removeItem = function (memberID, passedTeamID, passedClubID, memberType) {
    switch (memberType) {
      case `head-coach`:
        teamRemoveHeadCoachService(memberID, passedTeamID, memberRemovedCallback);
        break;
      case `coach`:
        teamRemoveCoachService(memberID, passedTeamID, memberRemovedCallback);
        break;
      case `player`:
        teamRemovePlayerService(memberID, passedTeamID, memberRemovedCallback);
        break;
      case `admin`:
        clubRemoveAdminService(memberID, passedClubID, memberRemovedCallback);
        break;
      case `team`:
        deleteTeamService(passedTeamID, memberRemovedCallback);
      // no default
    }
  };

  const memberRemovedCallback = function (response) {
    if (response.statusCode === 200) {
      $(`window`).notification({ title: response.message });
      animateDelete();
    } else {
      $(`window`).notification({ title: response.message, error: true });
    }
  };

  const animateDelete = function () {
    $(`.member-to-remove`).closest(`.member`).removeClass(`transition`).animate({
      'margin-left': `105%`,
    }, 600, function () {
      $(this).animate({
        height: `0px`,
        padding: `0px`,
        'margin-bottom': `0px`,
      }, function () {
        $(this).remove();
      });
    });
  };

  const init = function () {
    if ($managePage.length) {
      handleAddMemberClick();
      handleRemoveMemberClick();
      handleFormValidation();
    }
  };

  return { init };
}());

manageMembers.init();



// WEBPACK FOOTER //
// ./library/js/modules/manage-members.js